export const ACCESSIBILITY_STORAGE_KEY = 'headcount-a11y-prefs'

export const TEXT_SIZES = ['small', 'normal', 'large', 'xlarge'] as const
export type TextSize = (typeof TEXT_SIZES)[number]

export const CONTRAST_MODES = ['normal', 'high'] as const
export type ContrastMode = (typeof CONTRAST_MODES)[number]

export const MOTION_MODES = ['normal', 'reduced'] as const
export type MotionMode = (typeof MOTION_MODES)[number]

export type AccessibilitySettings = {
  textSize: TextSize
  contrast: ContrastMode
  motion: MotionMode
  underlineLinks: boolean
  dyslexiaFont: boolean
}

export const DEFAULT_ACCESSIBILITY_SETTINGS: AccessibilitySettings = {
  textSize: 'normal',
  contrast: 'normal',
  motion: 'normal',
  underlineLinks: false,
  dyslexiaFont: false,
}
